import React, {useState, useEffect, useContext} from "react"
import {useParams, useHistory} from 'react-router-dom'
import { AudioPlayerProvider } from 'react-use-audio-player'
import '../../css/pages/LocationPage.css'
import '../../css/animations.css'

import {LocationPuzzlesProvider} from '../../context/LocationPuzzlesContext'
import {UnmountContext} from '../../context/UnmountContext'
import {PlayerStatsContext} from '../../context/PlayerStatsContext'
import useTogglePopUp from '../../hooks/useTogglePopUp'

import GameHeader from '../../components/GameHeader'
import InfoPopUp from '../../components/InfoPopUp'

import SceneTextPanel from './SceneTextPanel'
import ClueSystem from './ClueSystem'
import Inventory from './Inventory'
import LocationInteraction from './LocationInteraction'
import TheMachine from './theMachine/TheMachine'
import OptionalBackToMap from './OptionalBackToMap'
import ForcedBackToMap from './ForcedBackToMap'

function LocationPage() {
    const {locationId} = useParams()
    const [displayMachine] = useState(() => locationId === 'machine' ? true : false) 
    const {togglePopUp, isPopUpOpen} = useTogglePopUp()
    const {playerStats} = useContext(PlayerStatsContext)
    const {unmount, updateUnmount} = useContext(UnmountContext)
    const route = useHistory()
        
    useEffect(() => {
        if (unmount.waiting && unmount.safe) { 
            switch(locationId) {
                case 'lastStand':
                    return route.push('/location/machine/story')
                
                case 'machine':
                    return route.push('/landing')
                
                default:
                    return route.push('/map') 
            }
        }
    }, [unmount, route, locationId])
    
    useEffect(() => {
        !isPopUpOpen && unmount.safe && updateUnmount({name: 'safe', state: false})
    }, [isPopUpOpen, unmount, updateUnmount])
    
    useEffect(() => {
        if (playerStats.[locationId] === 'locked' && !isPopUpOpen) {
            togglePopUp()
        }
    }, [playerStats, togglePopUp, locationId, isPopUpOpen])
        
    return (
        <div className="pageContainer pageContainer-location">
            <GameHeader>
                {locationId !== 'office' && locationId !== 'machine' &&
                    <p className="header_link header_link-returnToMap" onClick={togglePopUp}>
                        <i className="fas fa-map-marked-alt"></i> return to map
                    </p>
                }
                
            </GameHeader>
            
            {playerStats.[locationId] === 'open' && 
                <LocationPuzzlesProvider locationId={locationId}>
                    <aside className="side">
                        <SceneTextPanel />
                        <Inventory />
                        <AudioPlayerProvider><ClueSystem /></AudioPlayerProvider>
                    </aside>

                    <main className="main-location">
                        {displayMachine ? 
                            <AudioPlayerProvider>
                                <TheMachine 
                                    unmount={unmount}
                                    updateUnmount={updateUnmount}
                                />
                            </AudioPlayerProvider> : 
                            <LocationInteraction
                                unmount={unmount}
                                updateUnmount={updateUnmount}
                            />
                        }
                    </main>
                </LocationPuzzlesProvider>
            }
            
            <InfoPopUp isPopUpOpen={isPopUpOpen} togglePopUp={togglePopUp}>
                {
                    playerStats.[locationId] === 'open' ? 
                        <OptionalBackToMap
                            unmount={unmount}
                            updateUnmount={updateUnmount}
                            togglePopUp={togglePopUp}
                        /> :
                        <ForcedBackToMap
                            unmount={unmount}
                            updateUnmount={updateUnmount}
                        />
                }
            </InfoPopUp>
        </div>
    )
}

export default LocationPage